module.exports = __webpack_public_path__ + "static/media/crm_temp_clicked.c3dcf118.svg";